import { http } from '@/providers/apis/http';
import { reportsSerializer } from '@/providers/serializers/reports/reports';

export class ReportsAPI {
    private static INSTANCE = new ReportsAPI();

    private missionControlNamespace = 'api/missioncontrol/v1';

    static get instance() {
        return this.INSTANCE;
    }

    public fetchUsageSummaryReports(data: any) {
        const endpoint = `${this.missionControlNamespace}/roster/users/summary`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, data).then((response: any) => {
          return reportsSerializer.serializeSummaryReports(response.data);
        });
    }

    public fetchSubjectList(data: any) {
        const endpoint = `${this.missionControlNamespace}/tenants/subjects`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, data).then((response: any) => {
            return reportsSerializer.serializeSubjectList(response.data);
        });
    }

    public fetchUserCompetencyPerformance(data: any) {
        const endpoint = `${this.missionControlNamespace}/competency/user/performance`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, data).then((response: any) => {
            return reportsSerializer.serializeCompetencyDetails(response.data);
        });
    }
}



export const reportsApi = ReportsAPI.instance;
